import { render, staticRenderFns } from "./PassengersPage.vue?vue&type=template&id=7b3f9810&"
import script from "./PassengersPage.vue?vue&type=script&lang=js&"
export * from "./PassengersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports